// Reglas y utilidades de los archivos adjuntos de los chats (imágenes y PDF).
// El servidor vuelve a validar todo por el contenido real del archivo; aquí solo se evitan subidas inútiles.

// Mismos números que el servidor (server/config/limitesChat.js): él vuelve a validar y es quien manda.
export const MAX_ARCHIVOS = 3;
export const MAX_MB = 5;
// Los archivos de los chats se borran pasado este tiempo (server/config/limitesChat.js, retencion.dias); el mensaje conserva su texto
export const DIAS_CONSERVACION = 90;
const MAX_BYTES = MAX_MB * 1024 * 1024;

const MIMES_IMAGEN = ['image/jpeg', 'image/png', 'image/webp'];
const EXT_IMAGEN = ['jpg', 'jpeg', 'png', 'webp'];

// Valor del atributo accept del <input type="file">
export const ACEPTAR = `${MIMES_IMAGEN.join(',')},application/pdf,.jpg,.jpeg,.png,.webp,.pdf`;

export const MENSAJE_TIPOS = 'Solo se pueden adjuntar imágenes (JPG, PNG o WebP) y archivos PDF';

// 'imagen' | 'pdf' | null. Algunos navegadores no informan el tipo del archivo: entonces se usa la extensión.
export const tipoDeArchivo = (archivo) => {
  const mime = (archivo.type || '').toLowerCase();
  if (MIMES_IMAGEN.includes(mime)) return 'imagen';
  if (mime === 'application/pdf') return 'pdf';
  if (!mime) {
    const ext = (archivo.name.split('.').pop() || '').toLowerCase();
    if (EXT_IMAGEN.includes(ext)) return 'imagen';
    if (ext === 'pdf') return 'pdf';
  }
  return null;
};

// Separa los archivos que sí se pueden agregar de los que no, y devuelve el último motivo de rechazo.
export const validarArchivos = (actuales, nuevos) => {
  const aceptados = [];
  let error = '';
  const repetido = (f) => [...actuales, ...aceptados].some(
    (a) => a.name === f.name && a.size === f.size && a.lastModified === f.lastModified
  );
  for (const f of nuevos) {
    if (actuales.length + aceptados.length >= MAX_ARCHIVOS) {
      error = `Máximo ${MAX_ARCHIVOS} archivos por mensaje`;
      break;
    }
    if (!tipoDeArchivo(f)) { error = MENSAJE_TIPOS; continue; }
    if (f.size > MAX_BYTES) { error = `"${f.name}" pesa más de ${MAX_MB} MB`; continue; }
    if (repetido(f)) continue;
    aceptados.push(f);
  }
  return { aceptados, error };
};

// Adjunto ya enviado (lo que guarda el servidor): { url, nombre, tipo: 'imagen' | 'pdf', publicId }
export const esImagen = (adjunto) => adjunto?.tipo === 'imagen';

// Versión liviana de una imagen de Cloudinary: las fotos del celular pesan varios MB y no hace falta
// descargarlas completas para verlas en una burbuja.
export const urlOptimizada = (url, ancho) => (
  typeof url === 'string' && url.includes('/image/upload/')
    ? url.replace('/image/upload/', `/image/upload/w_${ancho},c_limit,q_auto,f_auto/`)
    : url
);
